import clsx from 'clsx';
import Button from '@components/atoms/button/button';
import { PropsWithChildren, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { isWebview } from '@helpers/routing';
import { useFocusRestore } from '@hooks/a11y/use-focus-restore';
import styles from './modal.module.scss';

interface ModalProps extends PropsWithChildren {
  open: boolean;
  title: string;
  onClose?: () => void;
  className?: string;
}

const Modal = ({ open, title, onClose, className, children }: ModalProps) => {
  const ref = useRef<HTMLDialogElement>(null);

  const { query } = useRouter();

  const isWebView = isWebview(query);

  // Automatically restore focus when modal closes
  useFocusRestore(open);

  useEffect(() => {
    if (open) {
      ref.current?.showModal();
    } else {
      ref.current?.close();
    }
  }, [open]);

  return (
    <dialog
      ref={ref}
      onCancel={onClose}
      className={clsx(styles.dialog, className)}
    >
      <div className={styles.header}>
        <h2 className={styles.header_title}>{title}</h2>

        {!!onClose && (
          <Button
            disableDefaultStyling
            className={clsx('vc-modal__closeBtn', styles.closeBtn, {
              [styles.unfocused]: isWebView, // IOS auto display focused, this is for remove it
            })}
            onClick={onClose}
          >
            <span className="vc-modal__closeBtn__crossLeft" />
            <span className="vc-modal__closeBtn__crossRight" />
          </Button>
        )}
      </div>

      <div className={styles.body}>{children}</div>
    </dialog>
  );
};

export default Modal;
